import colors from 'assets/theme/base/colors';
import borders from 'assets/theme/base/borders';
import typography from 'assets/theme/base/typography';

const { borderRadius } = borders;
const { size } = typography;

const menuItem = {
    styleOverrides: {
        root: {
            borderRadius: borderRadius.xs,
            fontSize: size.sm,
            color: colors.common.white,

            '&:hover, &:focus': {
                backgroundColor: colors.action.menuSelect,
                color: colors.common.white,
            },
        },
    },
};

export default menuItem;
